/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Return_To_Product_ButtonInputs */

const en_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Return to ${i?.displayName}`)
};

const id_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kembali ke ${i?.displayName}`)
};

const ms_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kembali ke ${i?.displayName}`)
};

const ca_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tornar a ${i?.displayName}`)
};

const cs_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vráti se do ${i?.displayName}`)
};

const da_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vend tilbage til ${i?.displayName}`)
};

const de_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zurück zu ${i?.displayName}`)
};

const et_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Naase kuvale ${i?.displayName}`)
};

const es_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volver a ${i?.displayName}`)
};

const fr_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Revenir à ${i?.displayName}`)
};

const hr_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vrati se na ${i?.displayName}`)
};

const it_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ritorna a ${i?.displayName}`)
};

const lv_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atgriezties uz ${i?.displayName}`)
};

const lt_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Grįžti į ${i?.displayName}`)
};

const hu_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vissza a ${i?.displayName} oldalra`)
};

const nl_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Terug naar ${i?.displayName}`)
};

const nb_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tilbake til ${i?.displayName}`)
};

const pl_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wróć do ${i?.displayName}`)
};

const pt_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voltar para ${i?.displayName}`)
};

const ro_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Întoarce-te la ${i?.displayName}`)
};

const sk_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vrátiť sa na ${i?.displayName}`)
};

const sl_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vrnitev na ${i?.displayName}`)
};

const fi_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palaa kohteeseen ${i?.displayName}`)
};

const sv_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gå tillbaka till ${i?.displayName}`)
};

const vi_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trở lại ${i?.displayName}`)
};

const tr_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} hesabına dön`)
};

const el_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Επιστροφή στο ${i?.displayName}`)
};

const bg_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Връщане към ${i?.displayName}`)
};

const ru_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вернуться к ${i?.displayName}`)
};

const sr_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Врати се на функцију ${i?.displayName}`)
};

const uk_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Повернутися до ${i?.displayName}`)
};

const ka_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`დაბრუნება ${i?.displayName}-ზე`)
};

const hi_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`रिटर्न टू ${i?.displayName}`)
};

const th_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`กลับไปที่ ${i?.displayName}`)
};

const ko_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName}(으)로 돌아가기`)
};

const zh_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`返回 ${i?.displayName}`)
};

const zh_tw_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`返回 ${i?.displayName}`)
};

const ja_return_to_product_button = /** @type {(inputs: Return_To_Product_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName}に戻る`)
};

/**
* | output |
* | --- |
* | "Return to {displayName}" |
*
* @param {Return_To_Product_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const return_to_product_button = /** @type {((inputs: Return_To_Product_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Return_To_Product_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_return_to_product_button(inputs)
	if (locale === "ms") return ms_return_to_product_button(inputs)
	if (locale === "ca") return ca_return_to_product_button(inputs)
	if (locale === "cs") return cs_return_to_product_button(inputs)
	if (locale === "da") return da_return_to_product_button(inputs)
	if (locale === "de") return de_return_to_product_button(inputs)
	if (locale === "et") return et_return_to_product_button(inputs)
	if (locale === "es") return es_return_to_product_button(inputs)
	if (locale === "fr") return fr_return_to_product_button(inputs)
	if (locale === "hr") return hr_return_to_product_button(inputs)
	if (locale === "it") return it_return_to_product_button(inputs)
	if (locale === "lv") return lv_return_to_product_button(inputs)
	if (locale === "lt") return lt_return_to_product_button(inputs)
	if (locale === "hu") return hu_return_to_product_button(inputs)
	if (locale === "nl") return nl_return_to_product_button(inputs)
	if (locale === "nb") return nb_return_to_product_button(inputs)
	if (locale === "pl") return pl_return_to_product_button(inputs)
	if (locale === "pt") return pt_return_to_product_button(inputs)
	if (locale === "ro") return ro_return_to_product_button(inputs)
	if (locale === "sk") return sk_return_to_product_button(inputs)
	if (locale === "sl") return sl_return_to_product_button(inputs)
	if (locale === "fi") return fi_return_to_product_button(inputs)
	if (locale === "sv") return sv_return_to_product_button(inputs)
	if (locale === "vi") return vi_return_to_product_button(inputs)
	if (locale === "tr") return tr_return_to_product_button(inputs)
	if (locale === "el") return el_return_to_product_button(inputs)
	if (locale === "bg") return bg_return_to_product_button(inputs)
	if (locale === "ru") return ru_return_to_product_button(inputs)
	if (locale === "sr") return sr_return_to_product_button(inputs)
	if (locale === "uk") return uk_return_to_product_button(inputs)
	if (locale === "ka") return ka_return_to_product_button(inputs)
	if (locale === "hi") return hi_return_to_product_button(inputs)
	if (locale === "th") return th_return_to_product_button(inputs)
	if (locale === "ko") return ko_return_to_product_button(inputs)
	if (locale === "zh") return zh_return_to_product_button(inputs)
	if (locale === "zh-tw") return zh_tw_return_to_product_button(inputs)
	if (locale === "ja") return ja_return_to_product_button(inputs)
	return en_return_to_product_button(inputs)
});